import styled from "styled-components";
import { smokeBlack } from "../../common/style/index";

export default styled.div`

  width: 100%;
  color: ${smokeBlack};

`